/** Syntax-highlighted span for VS Code Dark+ theme code previews */
const SyntaxSpan = ({ c, children }: { c: string; children: React.ReactNode }) => (
  <span style={{ color: c }}>{children}</span>
);

/* VS Code Dark+ palette tokens */
export const cm = '#546E3F';  // comment
export const kw = '#6FB3F2';  // keyword
export const fn = '#DCDCAA';  // function name
export const pr = '#9CDCFE';  // property/variable
export const st = '#CE9178';  // string
export const nm = '#B5CEA8';  // number

export default SyntaxSpan;
